package data.search_data

import models.SearchData

// Search suggestions (78)
val TajMahalSearchSuggestions = listOf(
    "bodhisattva",
    "shrine",
    "dagger",
    "alloy",
    "stone",
    "sculpture",
    "ink",
    "panel",
    "paper",
    "album",
    "schist",
    "leather",
    "katar",
    "folio",
    "textiles",
    "sandstone",
    "fragment",
    "coins",
    "male",
    "female",
    "illustrated",
    "relief",
    "red",
    "silk",
    "bronze",
    "jade",
    "black",
    "wood",
    "inlay",
    "single",
    "paintings",
    "painted",
    "steel",
    "manuscript",
    "buddha",
    "deity",
    "cotton",
    "crystal",
    "metalwork",
    "carved",
    "bowl",
    "portrait",
    "inlays",
    "plaque",
    "figure",
    "vishnu",
    "rubies",
    "leaf",
    "goddess",
    "copper",
    "shah",
    "brass",
    "coin",
    "silver",
    "terracotta",
    "king",
    "opaque",
    "metal",
    "iron",
    "blade",
    "standing",
    "ivory",
    "rock",
    "khanjar",
    "ruby",
    "shiva",
    "codices",
    "nephrite",
    "stele",
    "ivories",
    "work",
    "gold",
    "dyed",
    "watercolor",
    "seated",
    "box",
    "daggers",
    "inlaid",
    "head",
    "emerald",
    "armor",
    "textile",
    "sheath",
    "velvet",
    "jahan",
)

// Machu Picchu (366)
val TajMahalSearchData = listOf(
    SearchData(
        1049,
        38148,
        "Celestial Beauty (Surasundari)",
        "figure|marble|sculpture",
        "as/mobile-large/69_247.jpg",
        0.44
    ),
    SearchData(
        1024, 38574, "Jain Svetambara Tirthankara in Meditation", "figure|marble|sculpture",
        "as/mobile-large/DT5161.jpg", 0.80
    ),
    SearchData(
        1574, 453344, "Pierced Window Screen", "screen|red sandstone; pierced, carved|stone",
        "is/mobile-large/DP326717.jpg", 0.74
    ),
    SearchData(
        150, 38752, "Relief of a Female Deity", "relief fragment|terracotta|sculpture",
        "as/mobile-large/33_50_16.JPG", 0.64
    ),
    SearchData(
        649, 38254, "Section of a Diptych in Linga Form, Interior Depicting Shiva and Parvati",
        "portable linga section|chlorite schist|sculpture", "as/mobile-large/DT8677.jpg", 0.80
    ),
    SearchData(
        1794,
        22871,
        "Saber with Scabbard",
        "saber with scabbard|steel, gold, silver, jade (nephrite), diamonds, emeralds, pearls|swords",
        "aa/mobile-large/DP215265.jpg",
        0.75
    ),
    SearchData(
        1149,
        38934,
        "Tara",
        "figurine|bronze with silver inlay|sculpture",
        "as/mobile-large/DP310497.jpg",
        0.75
    ),
    SearchData(
        -33,
        38925,
        "Female Worshipper in Front of a Column Support",
        "figure and column|bronze|sculpture",
        "as/mobile-large/1987_142_316.jpg",
        0.42
    ),
    SearchData(
        0,
        38074,
        "Toy Model of a Cart",
        "cart|terracotta|sculpture",
        "as/mobile-large/1991_455_2_F.jpg",
        0.82
    ),
    SearchData(
        1850, 31849, "Dagger (Khanjar)", "dagger (khanjar)|steel, jade or agate, gold|daggers",
        "aa/mobile-large/36.25.679_001june2014.jpg", 0.56
    ),
    SearchData(
        1850, 31840, "Dagger", "dagger|steel, gold, jade, ruby|daggers",
        "aa/mobile-large/36.25.669_001june2014.jpg", 0.56
    ),
    SearchData(
        449, 38511, "Krishna Killing the Horse Demon Keshi", "relief|terracotta|sculpture",
        "as/mobile-large/DT5237.jpg", 0.80
    ),
    SearchData(
        -100, 65011, "The Sun God Surya(?) in His Chariot with Wives and Attendants",
        "bowl fragment|ivory|ivories", "as/mobile-large/DP158770.jpg", 1.33
    ),
    SearchData(1621, 444865, "Coin", "coin|gold|coins", "is/mobile-large/DP29.jpg", 1.00),
    SearchData(
        1800, 24292, "Shield (Dhàl)", "shield (dhàl)|leather, lacquer, gold leaf, silver|shields",
        "aa/mobile-large/DP153433.jpg", 1.25
    ),
    SearchData(
        1183,
        75201,
        "Foliate Pedestal for a Buddhist Image",
        "pedestal|partially gilded brass, copper base|metalwork",
        "as/mobile-large/DP208972.jpg",
        0.75
    ),
    SearchData(
        1049, 38420, "The God Danda and the Goddess Niksubha (Attendants of Surya, the Sun God)",
        "stele fragment|sandstone|sculpture", "as/mobile-large/1983_553.jpg", 0.60
    ),
    SearchData(
        100, 38103, "Standing Female Figure with an Offering", "figure|gold|sculpture",
        "as/mobile-large/1987_142_309_DT8680.jpg", 0.59
    ),
    SearchData(
        1570,
        451276,
        "\"Portrait of Zamana Beg, Mahabat Khan\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP246561.jpg",
        0.68
    ),
    SearchData(
        1649,
        453242,
        "Basin with Stylized Lotus Blossoms",
        "basin|marble|stone",
        "is/mobile-large/DT7746.jpg",
        1.25
    ),
    SearchData(
        -50,
        38575,
        "Plaque with a Royal Family",
        "plaque|terracotta|sculpture",
        "as/mobile-large/DT6881.jpg",
        0.80
    ),
    SearchData(
        -1250,
        50576,
        "Ax Blade",
        "ax|copper|metalwork",
        "as/mobile-large/2001_433_46.JPG",
        0.55
    ),
    SearchData(
        549,
        38395,
        "Head of a Male Figure",
        "head|terracotta|sculpture",
        "as/mobile-large/264800.jpg",
        1.04
    ),
    SearchData(
        -50,
        39320,
        "One from a Pair of Ear Ornaments (Prakaravapra Kundala)",
        "earring|gold, sheet, wire and granulation|jewelry",
        "as/mobile-large/DP-14791-007.jpg",
        1.37
    ),
    SearchData(
        1640, 453253, "Dagger with Hilt in the Form of a Blue Bull (Nilgai)",
        "dagger|hilt: nephrite  blade: watered steel|stone", "is/mobile-large/DP158315.jpg", 0.75
    ),
    SearchData(
        -50, 38089, "Auspicious Emblem with Four Dancing Figures", "rattle|terracotta|sculpture",
        "as/mobile-large/1987_142_379_O.jpg", 0.99
    ),
    SearchData(
        1683,
        38639,
        "Three Arches",
        "arches|wood|sculpture",
        "as/mobile-large/DP263684.jpg",
        1.68
    ),
    SearchData(
        -50,
        38549,
        "Rattle in the Form of a Crouching Yaksha (Male Nature Spirit)",
        "rattle|terracotta|sculpture",
        "as/mobile-large/DP-18264-001.jpg",
        0.78
    ),
    SearchData(
        1749,
        448936,
        "Tent Lining Fragment",
        "fragment|cotton, silk; plain weave, embroidered, quilted|textiles-embroidered",
        "is/mobile-large/wb-33.65.9.JPG",
        0.80
    ),
    SearchData(
        1587,
        74425,
        "Ten Elements for East Window of an Architectural Ensemble from a Jain Meeting Hall",
        "architectural element|teak with traces of color|sculpture",
        "as/mobile-large/hb_16.133.jpg",
        0.87
    ),
    SearchData(
        249, 38240, "The Conversion and Ordination of Nanda", "relief|limestone|sculpture",
        "as/mobile-large/DP-15581-020.jpg", 7.00
    ),
    SearchData(
        874, 719420, "Goddess Durga Slaying the Demon Mahisha", "stele|schist|sculpture",
        "as/mobile-large/DP-12769-001.jpg", 0.75
    ),
    SearchData(
        749,
        38964,
        "Stupa",
        "stupa|bronze|metalwork",
        "as/mobile-large/1987_142_144_276_O.jpg",
        0.67
    ),
    SearchData(
        483, 38198, "Standing Buddha Offering Protection", "figure|red sandstone|sculpture",
        "as/mobile-large/DT237.jpg", 0.80
    ),
    SearchData(
        1100, 39328, "Shiva as Lord of Dance (Nataraja)", "figure|copper alloy|sculpture",
        "as/mobile-large/DT240.jpg", 0.75
    ),
    SearchData(
        1640,
        453367,
        "Portrait of the Elephant  \"Alam Guman",
        "illustrated album leaf|opaque watercolor and gold on paper|codices",
        "is/mobile-large/DP234016.jpg",
        1.42
    ),
    SearchData(
        1749, 666471, "Bowl in shape of a shell", "wine cup|jade (nephrite)|jade",
        "as/mobile-large/DP-22439-001.jpg", 1.33
    ),
    SearchData(
        1799,
        56233,
        "Box with tray",
        "box with tray|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP108028.jpg",
        1.06
    ),
    SearchData(
        610, 39142, "Seated Buddha", "figure|bronze with silver and copper inlay|sculpture",
        "as/mobile-large/DT5712.jpg", 0.80
    ),
    SearchData(
        1800, 31863, "Dagger (Katar)", "dagger (katar)|steel, gold|daggers",
        "aa/mobile-large/36.25.693_002june2014.jpg", 0.56
    ),
    SearchData(
        885, 38928, "Enthroned Preaching Buddha", "shrine|bronze with silver inlay|sculpture",
        "as/mobile-large/1987_142_337_F_sf.jpg", 0.75
    ),
    SearchData(
        1699,
        38724,
        "Fragment from a Processional Car",
        "figure|wood|sculpture",
        "as/mobile-large/20_52_2.JPG",
        0.66
    ),
    SearchData(
        1749,
        666489,
        "Bowl with floral design",
        "bowl|jade (nephrite)|jade",
        "as/mobile-large/DP-22442-001.jpg",
        1.33
    ),
    SearchData(
        1149, 38143, "Vishnu with His Mount, Garuda, His Consort, Lakshmi, and Attendants",
        "stele|black stone|sculpture", "as/mobile-large/57_51_2.jpg", 0.50
    ),
    SearchData(
        1799, 56221, "Bowl", "bowl|jade (nephrite) with painted decoration|jade",
        "as/mobile-large/DP-14153-041.jpg", 1.33
    ),
    SearchData(
        199,
        38739,
        "Male Head",
        "head|terracotta|sculpture",
        "as/mobile-large/28_159_9.JPG",
        0.75
    ),
    SearchData(
        1587,
        452310,
        "Fragment of an Animal Carpet",
        "carpet fragment|cotton (warp and weft), wool (pile); asymmetrically knotted pile|textiles-rugs",
        "is/mobile-large/DT5457.jpg",
        1.39
    ),
    SearchData(
        1690,
        453673,
        "Nan va Halva (Breads and Sweets)",
        "illustrated manuscript|ink, opaque watercolor, and gold on paper  binding: leather|codices",
        "is/mobile-large/DP235872.jpg",
        0.69
    ),
    SearchData(
        1615,
        37855,
        "Krishna\"s Parents Search for Him",
        "painting|ink and opaque watercolor on paper|paintings",
        "as/mobile-large/DP156112.jpg",
        1.19
    ),
    SearchData(
        633,
        713007,
        "Vajrapani",
        "figure|gray chorite|sculpture",
        "as/mobile-large/LC-2016_241_sr1-001.jpg",
        0.57
    ),
    SearchData(
        1150,
        39202,
        "Standing Tara",
        "figure|bronze|sculpture",
        "as/mobile-large/LC-1993_524_1-001.jpg",
        0.67
    ),
    SearchData(
        1712,
        448476,
        "\"Prince With his Courtiers and Musicians\", Folio from the Davis Album",
        "illustrated  album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/sf30-95-174-17a.jpg",
        0.65
    ),
    SearchData(
        1800,
        31401,
        "Crutch Dagger (Zafar Takieh, \"Cushion of Victory\") with Sheath",
        "crutch dagger (zafar takieh) with sheath|steel, silver, gold, jade, ruby, turquoise, emerald|daggers",
        "aa/mobile-large/36.25.1001ab_004july2014.jpg",
        0.56
    ),
    SearchData(
        149,
        38729,
        "Ornamental Band",
        "relief|red sandstone|sculpture",
        "as/mobile-large/28_147_1.JPG",
        1.29
    ),
    SearchData(
        1625,
        445261,
        "Pashmina Carpet Fragment",
        "carpet fragment|silk (warp and weft), pashmina wool (pile); asymmetrically knotted pile|textiles-rugs",
        "is/mobile-large/DP229987.jpg",
        0.47
    ),
    SearchData(
        1400,
        39227,
        "Durga Mahishasura",
        "figure|bronze|sculpture",
        "as/mobile-large/1987_142_336.JPG",
        0.66
    ),
    SearchData(
        1800,
        31847,
        "Dagger (Khanjar) with Sheath",
        "dagger (khanjar) with sheath|steel, jade, gold, turquoise, crystal, garnet, ruby, gemstone silk, silver, copper|daggers",
        "aa/mobile-large/36.25.677ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        449, 38389, "Plaque with Figure Holding a Sword", "plaque|terracotta|sculpture",
        "as/mobile-large/DT6021.jpg", 0.80
    ),
    SearchData(
        1149,
        38771,
        "Relief of an Episode of Kiratarjuniya from the Mahabharata",
        "relief|schist|sculpture",
        "as/mobile-large/1970_13.JPG",
        2.67
    ),
    SearchData(
        1649,
        56206,
        "Dish",
        "dish|nephrite, white|jade",
        "as/mobile-large/02_18_758.JPG",
        1.38
    ),
    SearchData(
        1799, 56256, "Vase with stopper", "vase|jade (nephrite) with gold and silver inlays|jade",
        "as/mobile-large/DP-14153-019.jpg", 0.75
    ),
    SearchData(
        100, 38379, "Tree Spirit Deity (Yakshi)", "bracket|red sandstone|sculpture",
        "as/mobile-large/DP251641.jpg", 0.75
    ),
    SearchData(
        1800,
        24297,
        "Dagger with Sheath",
        "dagger with sheath|steel, rock crystal, gold, silver, rubies, diamonds, emeralds, textile, wood|daggers",
        "aa/mobile-large/23.232.8ab_003july2014.jpg",
        0.56
    ),
    SearchData(
        1749,
        56203,
        "Wine Cup",
        "wine cup|nephrite|jade",
        "as/mobile-large/32833.jpg",
        1.36
    ),
    SearchData(
        599, 38769, "Doorframe with Three Ganas (Nature Deities) Dancing and Playing Instruments",
        "doorframe fragment|sandstone|sculpture", "as/mobile-large/64_10.JPG", 0.57
    ),
    SearchData(
        599,
        72605,
        "Standing Goddess",
        "figure|bronze|sculpture",
        "as/mobile-large/DP238955.jpg",
        0.75
    ),
    SearchData(
        1650,
        453281,
        "Three Ornaments from a Bridle",
        "ornaments|silver; stamped, punched, gilded|metal",
        "is/mobile-large/1987.254.1-3-D.JPG",
        0.54
    ),
    SearchData(
        1650,
        453642,
        "Writing Box with Lattice and Flower Design",
        "writing box|wood; overlaid with dyed wool, stamped silver and gilt-copper plaques|metal",
        "is/mobile-large/DP240984.jpg",
        1.17
    ),
    SearchData(
        799,
        38149,
        "Bust of a Female Deity",
        "bust|stone|sculpture",
        "as/mobile-large/1987_418_1.jpg",
        0.50
    ),
    SearchData(
        250,
        38970,
        "Seated Ascetic, Deified King, Agni (The God of Fire)",
        "figure|bronze|sculpture",
        "as/mobile-large/DP155519.jpg",
        0.77
    ),
    SearchData(
        1624,
        73309,
        "Plate",
        "plate|mother-of-pearl with copper alloy base (underside) and rim frame|shell",
        "as/mobile-large/DP138506.jpg",
        1.00
    ),
    SearchData(
        1199, 38140, "Tree Dryad (Shalabhanjika)", "figure|ferruginous stone|sculpture",
        "as/mobile-large/65_108.jpg", 0.33
    ),
    SearchData(
        1149,
        37397,
        "Ganesha",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DP148767.jpg",
        0.75
    ),
    SearchData(
        1016,
        38931,
        "Crowned and Jeweled Buddha",
        "shrine|bronze with silver and copper inlay|sculpture",
        "as/mobile-large/1987_142_319_O.jpg",
        0.37
    ),
    SearchData(
        699, 38414, "Head of a Bodhisattva", "head|stucco on a clay core|sculpture",
        "as/mobile-large/29_11_F_sf.jpg", 1.22
    ),
    SearchData(
        849,
        39129,
        "Seated Maitreya",
        "figurine|bronze|sculpture",
        "as/mobile-large/1987_142_347_F.JPG",
        0.80
    ),
    SearchData(
        949, 38259, "Manjushri, the Bodhisattva of Transcendent Wisdom", "figure|brass|sculpture",
        "as/mobile-large/1983_555_5.jpg", 0.59
    ),
    SearchData(
        549,
        38601,
        "Gaja Lakshmi, Goddess of Fortune",
        "relief|stone|sculpture",
        "as/mobile-large/DP253395.jpg",
        0.75
    ),
    SearchData(
        1610,
        58449,
        "Krishna Dancing: Page from the Dispersed \"Boston\" Rasikapriya (Lover\"s Breviary)",
        "folio|ink, opaque watercolor, and gold on paper|paintings",
        "as/mobile-large/DP153225.jpg",
        0.63
    ),
    SearchData(
        1644,
        451288,
        "Rosette Bearing the Name and Title of Emperor Aurangzeb (Recto), from the Shah Jahan Album",
        "non-illustrated album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP247731.jpg",
        0.69
    ),
    SearchData(
        499, 38244, "Tile showing a woman carrying a pot", "tile|terracotta|sculpture",
        "as/mobile-large/1994_77.jpg", 1.23
    ),
    SearchData(
        1650,
        31861,
        "Dagger (Katar) with Sheath",
        "dagger (katar) with sheath|iron, gold, steel, diamond, velvet, wood|daggers",
        "aa/mobile-large/36.25.691ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        1799,
        56247,
        "Box with cover",
        "box|jade (nephrite) with gold, silver, and stone inlays|jade",
        "as/mobile-large/DP-14153-035.jpg",
        1.39
    ),
    SearchData(
        1650,
        448351,
        "Joined Fragments: Velvet Panel with Rows of Flowers",
        "joined fragments|silk, cut and voided velvet, with continuous floats of metal thread|textiles-woven",
        "is/mobile-large/DP230001.jpg",
        0.46
    ),
    SearchData(
        1116, 39331, "Yashoda with the Infant Krishna", "figure|copper alloy|sculpture",
        "as/mobile-large/DT7387.jpg", 0.80
    ),
    SearchData(
        -100,
        38737,
        "Soldier",
        "statuette|terracotta|sculpture",
        "as/mobile-large/28_159_14.jpg",
        0.46
    ),
    SearchData(1249, 38768, "Lion", "figure|stone|sculpture", "as/mobile-large/60_123.JPG", 1.16),
    SearchData(
        1799, 58448, "Box with cover", "box|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/32916.jpg", 1.27
    ),
    SearchData(
        274, 38238, "Drum panel depicting a stupa with the Buddha Descent from Trayastrimsa Heaven",
        "drum slab|limestone|sculpture", "as/mobile-large/DP-18912-001.jpg", 0.79
    ),
    SearchData(
        -50, 38578, "Rattle in the Form of a Crouching Grotesque Yaksha (Male Nature Spirit)",
        "rattle|terracotta|sculpture", "as/mobile-large/DP-14671-001.jpg", 0.71
    ),
    SearchData(
        1616,
        24907,
        "Dagger with Scabbard",
        "dagger with scabbard|steel, iron, gold, rubies, emeralds, glass, wood, textile|daggers",
        "aa/mobile-large/DP157706.jpg",
        0.72
    ),
    SearchData(
        1650,
        453330,
        "Velvet Panel with Rows of Flowers",
        "joined fragments|silk, cut and voided velvet, with continuous floats of flat metal thread|textiles-woven",
        "is/mobile-large/DP230001.jpg",
        0.46
    ),
    SearchData(
        1750,
        31570,
        "Dagger (Jambiya) with Sheath and Carrier",
        "dagger (jambiya) with sheath and carrier|steel, silver, jade, leather, wood, lacquer, velvet|daggers",
        "aa/mobile-large/36.25.980abc_007july2014.jpg",
        0.67
    ),
    SearchData(
        199, 38730, "Bodhisattva and Yaksha", "relief fragment|red sandstone|sculpture",
        "as/mobile-large/28_147_2.JPG", 1.19
    ),
    SearchData(
        -50,
        40098,
        "Plaque with Standing Yakshi",
        "plaque|wood|sculpture",
        "as/mobile-large/DP158749.jpg",
        0.75
    ),
    SearchData(
        791, 38134, "Garuda (Vishnu\"s Mount) Seated in Royal Ease", "figure|granite|sculpture",
        "as/mobile-large/DT7595.jpg", 0.80
    ),
    SearchData(
        1700,
        31838,
        "Dagger",
        "dagger|steel, nephrite, silver, gold|daggers",
        "aa/mobile-large/DP157414.jpg",
        0.75
    ),
    SearchData(
        1049,
        38132,
        "Carved Conch",
        "carved conch|shell|sculpture",
        "as/mobile-large/DP-17091-001.jpg",
        0.75
    ),
    SearchData(
        1622,
        444861,
        "Coin with Sign of Cancer",
        "coin|silver|coins",
        "is/mobile-large/LC-99_35_2397.jpg",
        1.00
    ),
    SearchData(
        1800,
        200032,
        "Chessmen (32)",
        "chessmen|ivory with polychrome lacquer and gilding|chess sets",
        "es/mobile-large/DP-18258-011.jpg",
        1.64
    ),
    SearchData(
        1597,
        446562,
        "\"Bahram Gur Sees a Herd of Deer Mesmerized by Dilaram\" s Music\", Folio from a Khamsa (Quintet) of Amir Khusrau Dihlavi",
        "folio from an illustrated manuscript|main support: ink, opaque watercolor, and gold on paper  margins: gold on dyed paper|codices",
        "is/mobile-large/DP120803.jpg",
        0.69
    ),
    SearchData(
        261,
        38634,
        "Crowned  Bodhisattva",
        "bust|sandstone|sculpture",
        "as/mobile-large/DP701395.jpg",
        0.85
    ),
    SearchData(
        1083,
        75960,
        "Child Saint Sambandar",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DP234672.jpg",
        0.75
    ),
    SearchData(
        -1250, 50588, "Eccentric Anthropomorph", "anthropomorph|copper|metalwork",
        "as/mobile-large/2001_433_7_O.JPG", 1.11
    ),
    SearchData(
        1635,
        65584,
        "Krishna Revels with the Gopis: Page from a Dispersed Gita Govinda (Song of the Cowherds)",
        "folio|opaque watercolor and silver on paper|paintings",
        "as/mobile-large/DP152290.jpg",
        0.58
    ),
    SearchData(
        1787,
        506151,
        "Vina (वीणा)",
        "vina|jackwood, gold leaf, papier-mâché, bone, steel, brass|chordophone-lute-plucked-fretted",
        "mi/mobile-large/DP-15104-001.jpg",
        1.65
    ),
    SearchData(
        899,
        38136,
        "Jyeshtha  Flanked by Her Children",
        "figures|granite|sculpture",
        "as/mobile-large/DT8567.jpg",
        0.80
    ),
    SearchData(
        1649, 646829, "Filigree Casket with Sliding Top", "box|silver filigree; parcel-gilt|metal",
        "is/mobile-large/DP340529.jpg", 0.78
    ),
    SearchData(
        1699,
        447086,
        "Finial in the Form of a Parrot",
        "finial|brass|metal",
        "is/mobile-large/DT4880.jpg",
        1.25
    ),
    SearchData(
        1749, 56211, "Bowl in the shape of a chrysanthemum flower", "bowl|jade (nephrite)|jade",
        "as/mobile-large/DP108021.jpg", 1.50
    ),
    SearchData(
        1800, 31687, "Dagger (Khanjar)", "dagger (khanjar)|steel, jade|daggers",
        "aa/mobile-large/36.25.707_001june2014.jpg", 0.56
    ),
    SearchData(
        1800, 31467, "Dagger (Katar)", "dagger (katar)|steel, gold|daggers",
        "aa/mobile-large/36.25.1071_001july2014.jpg", 0.56
    ),
    SearchData(
        1949, 44670, "Head of a Male Deity (Study Collection)", "head|stone|sculpture",
        "as/mobile-large/1991_453_3.JPG", 0.60
    ),
    SearchData(
        -1250,
        50610,
        "Antennae Sword",
        "antennae sword|copper|metalwork",
        "as/mobile-large/2001_433_50_O.JPG",
        0.27
    ),
    SearchData(
        1750,
        24423,
        "Ceremonial Mace",
        "ceremonial mace|rock crystal, gold, copper alloy, ruby|shafted weapons",
        "aa/mobile-large/DP163751.jpg",
        0.80
    ),
    SearchData(
        649, 38250, "Linga with Face of Shiva (Ekamukhalinga)", "linga|stone|sculpture",
        "as/mobile-large/DT6118.jpg", 0.80
    ),
    SearchData(
        1700,
        453339,
        "Elephant Goad",
        "elephant goad|steel or iron, inlaid with gold and silver|metal",
        "is/mobile-large/DP231148.jpg",
        0.75
    ),
    SearchData(
        787,
        38515,
        "Vaikuntha Vishnu",
        "figure|stone|sculpture",
        "as/mobile-large/DT5253.jpg",
        0.80
    ),
    SearchData(
        1779,
        456949,
        "Great Indian Fruit Bat",
        "illustrated single work|pencil, ink, and opaque watercolor on paper|paintings",
        "is/mobile-large/DP167067.jpg",
        1.36
    ),
    SearchData(
        849, 38128, "Sealing Depicting the Buddha at the Mahabodhi Temple, Bodhgaya",
        "sealing|terracotta|sculpture", "as/mobile-large/33_50_10_F_sf.jpg", 0.98
    ),
    SearchData(
        1577,
        451280,
        "\"Portrait of Ibrahim \"Adil Shah II of Bijapur\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP159395.jpg",
        0.73
    ),
    SearchData(
        -50,
        40101,
        "Plaque with Erotic Scene",
        "plaque|bone|sculpture",
        "as/mobile-large/1999_226_1.jpg",
        1.08
    ),
    SearchData(
        1750,
        24208,
        "Arm Guard (Dastana)",
        "arm guard (dastana)|steel, gold, textile (velvet), textile (silk), textile (linen), copper alloy|armor parts",
        "aa/mobile-large/DP-651-001.jpg",
        1.08
    ),
    SearchData(
        1799,
        74696,
        "Design of Intertwining Animals and Plants",
        "painting|ink, opaque and translucent watercolor on paper|paintings",
        "as/mobile-large/DP166103.jpg",
        1.58
    ),
    SearchData(
        -50,
        38473,
        "Rattle in the Form of a Crouching Yaksha (Male Nature Spirit)",
        "rattle|terracotta|sculpture",
        "as/mobile-large/DP-18263-001.jpg",
        0.91
    ),
    SearchData(
        -94,
        38612,
        "Dish with a Bee Pollinating a Lotus",
        "dish|ceramic|ceramics",
        "as/mobile-large/1993_371.jpg",
        1.00
    ),
    SearchData(
        1837,
        781965,
        "Album of Hindu deities",
        "album|watercolor, ink, and gold on paper|manuscripts",
        "as/mobile-large/LC-TR_100ai_2018_012_crd.jpg",
        0.73
    ),
    SearchData(674, 38125, "Vishnu", "figure|stone|sculpture", "as/mobile-large/DT7427.jpg", 0.80),
    SearchData(
        1578,
        451281,
        "\"Portrait of Mulla Muhammad Khan Vali of Bijapur\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP247726.jpg",
        0.67
    ),
    SearchData(
        649, 37533, "Varuna Holding a Noose and Riding a Swan", "figure|sandstone|sculpture",
        "as/mobile-large/19_90.JPG", 0.89
    ),
    SearchData(
        1580,
        451268,
        "\"Akbar With Lion and Calf\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DT200627.jpg",
        0.66
    ),
    SearchData(
        449,
        38512,
        "Rondel with a Racing Male Deity Cradling His Consort (Probably Shiva and Parvati)",
        "rondel|terracotta|sculpture",
        "as/mobile-large/1991_263.jpg",
        0.98
    ),
    SearchData(
        -1875, 39126, "Woman Riding Two Brahman Bulls", "sculpture|bronze|sculpture",
        "as/mobile-large/DP702288.jpg", 0.75
    ),
    SearchData(
        1649,
        56232,
        "Box with Cover",
        "box with cover|nephrite, gray with faint greenish tint|jade",
        "as/mobile-large/32914.jpg",
        1.32
    ),
    SearchData(
        449, 38392, "Head Fragment from a Plaque", "head fragment|terracotta|sculpture",
        "as/mobile-large/1987_424_24.jpg", 0.86
    ),
    SearchData(
        1850,
        24006,
        "Shirt and Leg Defenses of Mail",
        "shirt and leg defenses of mail|iron, brass|mail",
        "aa/mobile-large/DP147307.jpg",
        1.00
    ),
    SearchData(
        1597,
        446567,
        "\"The Story of the Princess of the Blue Pavillion: The Youth of Rum Is Entertained in a Garden by a Fairy and her Maidens\", Folio from a Khamsa (Quintet) of Amir Khusrau Dihlavi",
        "folio from an illustrated manuscript|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP120808.jpg",
        0.68
    ),
    SearchData(
        -1250,
        50637,
        "Ax Blade",
        "ax|copper|metalwork",
        "as/mobile-large/2001_433_35.jpg",
        0.50
    ),
    SearchData(
        1799,
        56231,
        "Jar with cover",
        "jar with cover|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP108027.jpg",
        1.00
    ),
    SearchData(
        1837,
        24483,
        "Flintlock Gun",
        "flintlock gun|steel, ebony, gold, enamel, rubies, emeralds, textile|firearms-guns-flintlock",
        "aa/mobile-large/DP166296.jpg",
        2.68
    ),
    SearchData(
        1850,
        31851,
        "Dagger (Khanjar) with Sheath",
        "dagger (khanjar) with sheath|steel, jade, gold, velvet, pearl, turquoise, wood|daggers",
        "aa/mobile-large/36.25.681ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        1799, 56254, "Buckle", "buckle|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP108038.jpg", 1.27
    ),
    SearchData(
        1650,
        24306,
        "Dagger (Katar) and Sheath",
        "dagger (katar) and sheath|steel, leather, gold|daggers",
        "aa/mobile-large/DP158187.jpg",
        1.62
    ),
    SearchData(
        1949, 38773, "Head of a Buddha (Study Collection)", "figure|stone|sculpture",
        "as/mobile-large/1991_381_12.JPG", 0.70
    ),
    SearchData(
        250, 38241, "Naga Attendant Holding a Fly Whisk", "relief|limestone|tablets and plaques",
        "as/mobile-large/DP-18916-001.jpg", 0.30
    ),
    SearchData(
        -1250,
        50630,
        "Ax Blade (Celt)",
        "ax blade|copper|metalwork",
        "as/mobile-large/2001_433_20_O.JPG",
        0.75
    ),
    SearchData(
        1049,
        38142,
        "Celestial Musician (Gandharva)",
        "figure|slate|sculpture",
        "as/mobile-large/DP206242.jpg",
        0.75
    ),
    SearchData(
        -50,
        38468,
        "Yaksha",
        "yaksha|sandstone|sculpture",
        "as/mobile-large/DP-18910-001.jpg",
        0.70
    ),
    SearchData(
        435, 39405, "Gold Coin Showing King Kumaragupta as an Archer", "coin|gold|metalwork",
        "as/mobile-large/1990_319_1.jpg", 1.03
    ),
    SearchData(
        774,
        38598,
        "Kamadeva, the God of Love",
        "bust|stone|sculpture",
        "as/mobile-large/DP130033.jpg",
        0.75
    ),
    SearchData(
        1799,
        56225,
        "Bracelet",
        "bracelet|jade (nephrite) with gold, enamel, and stone inlays|jade",
        "as/mobile-large/DP108025.jpg",
        1.22
    ),
    SearchData(
        1850,
        31831,
        "Dagger (Khanjar)",
        "dagger (khanjar)|steel, jade, gold, ruby, emerald, beryl, rock crystal, turquoise|daggers",
        "aa/mobile-large/36.25.658_001june2014.jpg",
        0.56
    ),
    SearchData(
        438, 39892, "Nagini (Serpent Queen or Consort of Nagaraja)", "figure|stone|sculpture",
        "as/mobile-large/DT5825.jpg", 0.80
    ),
    SearchData(
        1798,
        1986,
        "Chess set",
        "chess set|lacquered wood, ivory|",
        "ad/mobile-large/138425.jpg",
        1.66
    ),
    SearchData(
        199,
        38736,
        "Bust of a Woman",
        "bust|terracotta|sculpture",
        "as/mobile-large/28_159_13.JPG",
        0.71
    ),
    SearchData(
        499,
        38197,
        "Tile with Impressed Figures of Emaciated Ascetics and Couples behind Balconies and Ganders",
        "tile|terracotta|sculpture",
        "as/mobile-large/1995_570_6.JPG",
        0.64
    ),
    SearchData(
        1800,
        31441,
        "Knife with Sheath",
        "knife with sheath|steel, jade, silver, emerald, ruby, gold|knives",
        "aa/mobile-large/36.25.1045ab_002july2014.jpg",
        0.56
    ),
    SearchData(
        1949, 44672, "Woman with a Parrot (Study Collection)", "relief fragment|stone|sculpture",
        "as/mobile-large/1991_453_5.JPG", 0.88
    ),
    SearchData(
        1750,
        31714,
        "Crutch Dagger (Zafar Takieh, \"Cushion of Victory\")",
        "crutch dagger|jade, steel|daggers",
        "aa/mobile-large/36.25.734_005june2014.jpg",
        0.56
    ),
    SearchData(
        1049, 38123, "Buddha Preaching the First Sermon at Sarnath", "figure|black stone|sculpture",
        "as/mobile-large/4 DP314867r4_61A.jpg", 0.75
    ),
    SearchData(
        1850, 31828, "Dagger", "dagger|steel, rock crystal, gold, ruby, emerald|daggers",
        "aa/mobile-large/36.25.655_001june2014.jpg", 0.56
    ),
    SearchData(
        1624,
        444867,
        "Coin with Sign of Leo",
        "coin|gold|coins",
        "is/mobile-large/DP33.jpg",
        1.00
    ),
    SearchData(
        1725,
        27218,
        "Shield",
        "shield|wood, leather, lacquer, gold, pigment, gesso, copper alloy, iron|shields",
        "aa/mobile-large/sfsb14.25.728_001.jpg",
        1.00
    ),
    SearchData(
        50, 73258, "Jewelry Mold with Figures in a Temple", "jewelry mold|argillite|sculpture",
        "as/mobile-large/DP143664.jpg", 1.33
    ),
    SearchData(
        449,
        38533,
        "Head of a Buddha",
        "figure|stone|sculpture",
        "as/mobile-large/DP145451.jpg",
        1.00
    ),
    SearchData(
        1649,
        448241,
        "Panel from a Tent Lining",
        "fragment of a tent lining|cotton; plain weave, mordant painted and dyed, resist dyed|textiles-painted and/or printed",
        "is/mobile-large/ad-29.68.2.JPG",
        0.75
    ),
    SearchData(
        1570,
        451266,
        "\"A Youth Fallen From a Tree\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP240815.jpg",
        0.67
    ),
    SearchData(
        1800, 31836, "Dagger", "dagger|steel, jade, gold, diamond, emerald, ruby, agate|daggers",
        "aa/mobile-large/36.25.664_001june2014.jpg", 0.56
    ),
    SearchData(
        1762,
        688478,
        "Casket",
        "casket|ebony and engraved ivory, tortoiseshell; mirror glass; silver hardware; brass feet; iron lock|natural substances-ivory",
        "es/mobile-large/DP-12252-017.jpg",
        1.29
    ),
    SearchData(
        1799,
        56234,
        "Sword handle in the shape of a horse’s head",
        "sword handle|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP108029.jpg",
        1.00
    ),
    SearchData(1618, 444866, "Coin", "coin|gold|coins", "is/mobile-large/DP31.jpg", 1.00),
    SearchData(
        1700,
        31865,
        "Dagger (Katar) with Sheath",
        "dagger (katar) with sheath|steel, gold, velvet, wood|daggers",
        "aa/mobile-large/36.25.697ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        799, 38247, "Vishnu Rescuing Gajendra, the Lord of the Elephants", "stele|stone|sculpture",
        "as/mobile-large/1986_306.jpg", 0.82
    ),
    SearchData(
        199, 38599, "Architectural Frieze with Merman Playing Musical Instruments",
        "architectural frieze|red sandstone|sculpture", "as/mobile-large/1993_192ab_O.jpg", 7.54
    ),
    SearchData(
        1680,
        453183,
        "The House of Bijapur",
        "illustrated  album leaf|ink, opaque watercolor, gold, and silver on paper|codices",
        "is/mobile-large/DP231353.jpg",
        0.76
    ),
    SearchData(
        1749,
        856419,
        "Processional image of the goddess Gauri",
        "head|brass with glass inlay and silver attachments|sculpture",
        "as/mobile-large/DP-23603-002.jpg",
        0.75
    ),
    SearchData(
        1674,
        457020,
        "Pair of Flower Style Doors",
        "pair of doors|wood; carved with residues of paint|wood",
        "is/mobile-large/DP230666.jpg",
        0.53
    ),
    SearchData(
        1600,
        453366,
        "Bidri Box for Holding Pan",
        "box|zinc alloy; cast, engraved, inlaid with silver and brass (bidri ware)|metal",
        "is/mobile-large/DP221344.jpg",
        0.75
    ),
    SearchData(
        1449,
        39263,
        "Seated Jain Tirthankara",
        "figure|bronze|sculpture",
        "as/mobile-large/DP124075.jpg",
        1.00
    ),
    SearchData(
        -1250,
        50595,
        "Harpoon",
        "harpoon|copper|metalwork",
        "as/mobile-large/2001_433_72_O.JPG",
        0.39
    ),
    SearchData(
        1799,
        56226,
        "Bracelet (one of a pair)",
        "bracelet|jade (nephrite) with gold, enamel, and stone inlays|jade",
        "as/mobile-large/DP108025.jpg",
        1.22
    ),
    SearchData(
        -50, 38092, "Plaque with a Dancer and a Vina Player", "plaque|terracotta|sculpture",
        "as/mobile-large/DT8684.jpg", 0.80
    ),
    SearchData(
        1550,
        679021,
        "Elephant Sword",
        "elephant sword|iron or steel|swords",
        "aa/mobile-large/DP350518.jpg",
        1.71
    ),
    SearchData(
        1687,
        453214,
        "Painted and Inlaid Game Board",
        "game board|wood; painted, varnished and gilded; with metal hinges|wood",
        "is/mobile-large/DP303328.jpg",
        1.15
    ),
    SearchData(
        1875,
        501899,
        "Karnā  (Trumpet)",
        "karnā (trumpet)|brass|aerophone-lip vibrated-trumpet / trombone",
        "mi/mobile-large/DP-12679-025.jpg",
        1.84
    ),
    SearchData(
        549, 38202, "Standing Male Deity (possibly Shiva)", "figure|stone|sculpture",
        "as/mobile-large/1993_477_4.jpg", 0.44
    ),
    SearchData(
        549, 38453, "Standing Jain Tirthankara Parshvanatha", "figure|sandstone|sculpture",
        "as/mobile-large/CT_35465.jpg", 0.51
    ),
    SearchData(
        249,
        37640,
        "Yakshi",
        "statuette|brown sandstone|sculpture",
        "as/mobile-large/33_50_1.JPG",
        0.62
    ),
    SearchData(
        749, 39342, "The Bodhisattva Vajrasattva", "figure|brass with silver inlay|sculpture",
        "as/mobile-large/DP130035.jpg", 0.75
    ),
    SearchData(
        499, 38393, "Lion Standing on a Pillar Capital", "capital|terracotta|sculpture",
        "as/mobile-large/28_159_7.jpg", 0.51
    ),
    SearchData(
        699, 38412, "Head of a Bodhisattva", "head|stucco on a clay core|sculpture",
        "as/mobile-large/33_50_3_F_sf.jpg", 1.23
    ),
    SearchData(
        -100, 65010, "The Moon God Chandra(?) in His Chariot with Wife and Attendant",
        "bowl fragment|ivory|ivories", "as/mobile-large/DP110808.jpg", 1.20
    ),
    SearchData(
        749, 38514, "The Brahmanical Triad:  Brahma, Shiva, Vishnu", "group|stone|sculpture",
        "as/mobile-large/1985_85_O.jpg", 1.06
    ),
    SearchData(
        1150,
        38563,
        "Twelve-Armed Chakrasamvara and His Consort Vajravarahi",
        "figure|phyllite|sculpture",
        "as/mobile-large/39 DP310521R1_61D.jpg",
        0.75
    ),
    SearchData(
        849,
        38387,
        "Seated Kubera (Study Collection)",
        "figure|stone|sculpture",
        "as/mobile-large/1984_318.JPG",
        0.70
    ),
    SearchData(
        1599,
        447796,
        "Royal Horse and Runner",
        "illustrated  album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DT4799.jpg",
        1.51
    ),
    SearchData(
        1649,
        453276,
        "\"The Battle of Shahbarghan\", Folio from a Padshahnama (Chronicle of the Emperor)",
        "folio from an illustrated manuscript|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DT8442.jpg",
        0.68
    ),
    SearchData(
        0, 40097, "Plaque with a Winged Goddess and Two Attendants", "plaque|ivory|ivories",
        "as/mobile-large/2004_553_2.JPG", 0.77
    ),
    SearchData(
        0,
        38518,
        "Goddess and Attendants",
        "plaque|terracotta|sculpture",
        "as/mobile-large/h1_1990.281.jpg",
        0.81
    ),
    SearchData(
        1649, 56209, "Shallow Bowl", "bowl|nephrite, very light opalescent yellowish-gray|jade",
        "as/mobile-large/02_18_761.JPG", 1.54
    ),
    SearchData(
        1850,
        31444,
        "Dagger with Sheath",
        "dagger with sheath|steel, jade, silver, gold, leather, wood, coral, turquoise|daggers",
        "aa/mobile-large/36.25.1048ab_002july2014.jpg",
        0.56
    ),
    SearchData(
        1099, 38139, "Preening Celestial Deity", "figure|ferruginous stone|sculpture",
        "as/mobile-large/264792.jpg", 0.34
    ),
    SearchData(
        1632,
        35633,
        "Shirt of Mail and Plate of Emperor Shah Jahan (reigned 1624-58)",
        "shirt of mail and plate|steel, iron, gold, leather|mail",
        "aa/mobile-large/DP219616.jpg",
        0.75
    ),
    SearchData(
        699,
        37413,
        "Panel from a Portable Shrine: The Descent of the Buddha from Trayastrimsha Heaven",
        "portable shrine panel|ivory with traces of color|ivories",
        "as/mobile-large/DP267829.jpg",
        0.75
    ),
    SearchData(
        1800,
        64852,
        "Royal Lovers in a Landscape Setting",
        "album leaf|leaf from an album; ink, colors and gold on paper|paintings",
        "as/mobile-large/64_167_15.jpg",
        0.68
    ),
    SearchData(
        949,
        38743,
        "Head of a Female",
        "head|red sandstone|sculpture",
        "as/mobile-large/33_50_4.JPG",
        0.83
    ),
    SearchData(
        438,
        38196,
        "Nagaraja (Serpent King)",
        "figure|stone|sculpture",
        "as/mobile-large/1987_415_1.jpg",
        0.57
    ),
    SearchData(
        1800, 31428, "Dagger with Sheath", "dagger with sheath|steel, jade, leather, wood|daggers",
        "aa/mobile-large/36.25.1031ab_003july2014.jpg", 0.56
    ),
    SearchData(
        1849,
        500709,
        "Taūs (mayuri)",
        "taūs (mayuri)|wood, parchment, metal, feathers|chordophone-lute-bowed-fretted",
        "mi/mobile-large/MI89.4.163.jpg",
        1.51
    ),
    SearchData(
        1850,
        31691,
        "Dagger (Jambiya) with Sheath",
        "dagger (jambiya) with sheath|steel, marble, gold, silver, silk, wood|daggers",
        "aa/mobile-large/36.25.711ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        1675,
        23725,
        "Priming Flask",
        "priming flask|ivory, steel, pigment, resin|firearms accessories-flasks & primers",
        "aa/mobile-large/DP158306.jpg",
        1.58
    ),
    SearchData(
        1650,
        31845,
        "Dagger (Khanjar)",
        "dagger (khanjar)|steel, ivory (elephant), gemstone, gold|daggers",
        "aa/mobile-large/36.25.675_001june2014.jpg",
        0.56
    ),
    SearchData(
        1778, 22848, "Cuirass", "cuirass|steel, iron, textile (velvet)|armor parts-cuirasses",
        "aa/mobile-large/DP219403.jpg", 0.79
    ),
    SearchData(
        899, 38435, "Diadem with Kinnaris (Half-Bird, Half-Female Creatures)",
        "diadem|gold inset with garnet|jewelry", "as/mobile-large/DP-14791-023.jpg", 1.80
    ),
    SearchData(
        1687,
        453243,
        "Base for a Water Pipe (Huqqa) with Irises",
        "water pipe base|zinc alloy; cast, engraved, inlaid with brass (bidri ware)|metal",
        "is/mobile-large/DP214317.jpg",
        0.75
    ),
    SearchData(
        1016,
        39327,
        "Shiva, Uma, and Their Son Skanda (Somaskandamurti)",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DT7390.jpg",
        1.25
    ),
    SearchData(
        849, 38256, "Shiva and Parvati with their Sons Karttikeya and Ganesha and the Calf Bull",
        "figure|stone|sculpture", "as/mobile-large/DT6248.jpg", 0.80
    ),
    SearchData(
        1799, 56223, "Oval box with cover", "box|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP108024.jpg", 1.19
    ),
    SearchData(
        395, 39406, "Gold Coin Showing King Chandragupta II as an Archer", "coin|gold|jewelry",
        "as/mobile-large/1990_319_2.jpg", 1.07
    ),
    SearchData(
        649,
        78910,
        "Lakshmi, Goddess of Prosperity",
        "figure|brass|sculpture",
        "as/mobile-large/DP326749.jpg",
        0.75
    ),
    SearchData(150, 38758, "Lamp", "lamp|stone|sculpture", "as/mobile-large/33_50_22.JPG", 1.47),
    SearchData(
        199,
        38738,
        "Head with Hat",
        "head|terracotta|sculpture",
        "as/mobile-large/28_162_2.JPG",
        0.57
    ),
    SearchData(
        749, 39341, "Karttikeya, the God of War", "figure|brass with silver inlay|sculpture",
        "as/mobile-large/DP702274.jpg", 0.69
    ),
    SearchData(
        1875, 500736, "Ghanti (bell)", "ghanti (bell)|brass|idiophone-struck-bell-clapper",
        "mi/mobile-large/mi89.4.154.R.jpg", 0.66
    ),
    SearchData(
        1749,
        56237,
        "Dish",
        "dish|jade (nephrite) with silver inlays|jade",
        "as/mobile-large/02_18_780.JPG",
        1.68
    ),
    SearchData(
        1725,
        454013,
        "Footed Bowl and Plate",
        "bowl and dish|glass, opalescent white; blown, bowl with applied stem and blown applied foot, fired silver and gold decoration|glass",
        "is/mobile-large/DT4697.jpg",
        1.25
    ),
    SearchData(
        250, 38754, "Relief of a Female Deity", "relief fragment|terracotta|sculpture",
        "as/mobile-large/33_50_18.JPG", 0.69
    ),
    SearchData(
        950,
        38929,
        "Seated Tara",
        "figure|bronze|sculpture",
        "as/mobile-large/1987_142_343.JPG",
        0.68
    ),
    SearchData(
        499,
        53472,
        "Bust of Vishnu",
        "bust|terracotta|sculpture",
        "as/mobile-large/2000_82.jpg",
        0.65
    ),
    SearchData(
        300, 49817, "Box Lid with Incised Figural Decoration", "box lid|ivory|ivories",
        "as/mobile-large/DT4347.jpg", 1.25
    ),
    SearchData(
        999, 38260, "Shrine Relief Fragment Depicting Ashtamahabhaya Tara, the Buddhist Savioress",
        "fragment|wood|sculpture", "as/mobile-large/30 DP130034R1_61C.jpg", 0.56
    ),
    SearchData(
        1612,
        453261,
        "Pierced Window Screen (Jali)",
        "screen|marble|stone",
        "is/mobile-large/DP-19479-001.jpg",
        0.63
    ),
    SearchData(
        1049,
        38146,
        "Vishnu",
        "stele|sandstone|sculpture",
        "as/mobile-large/DT5052.jpg",
        0.79
    ),
    SearchData(
        1149,
        39251,
        "Yoga Narasimha, Vishnu\"s Man-Lion Incarnation",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DP237096.jpg",
        0.75
    ),
    SearchData(
        1800,
        24793,
        "Cuirass (Char-aina)",
        "cuirass (char-aina)|steel, gold, textile|armor parts-cuirasses",
        "aa/mobile-large/DP151798.jpg",
        1.00
    ),
    SearchData(
        1049,
        38945,
        "Hanuman Conversing",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DT5250.jpg",
        0.80
    ),
    SearchData(
        1250,
        38947,
        "Standing Shiva",
        "figure|bronze|sculpture",
        "as/mobile-large/1979_508.jpg",
        0.64
    ),
    SearchData(
        1050,
        38153,
        "Celestial dancer (Devata)",
        "figure|sandstone|sculpture",
        "as/mobile-large/DP-1062-001.jpg",
        0.83
    ),
    SearchData(
        1849,
        503672,
        "Śankh",
        "śankh|shell (turbinella pyrum), brass, wax|aerophone-lip vibrated-trumpet / trombone",
        "mi/mobile-large/DP353270.jpg",
        1.33
    ),
    SearchData(
        1750,
        31726,
        "Dagger (Katar)",
        "dagger (katar)|steel|daggers",
        "aa/mobile-large/36.25.746_003june2014.jpg",
        0.56
    ),
    SearchData(
        1750, 24301, "Dagger (Katar)", "dagger (katar)|steel, gold|daggers",
        "aa/mobile-large/36.25.696_002july2014.jpg", 0.56
    ),
    SearchData(1649, 56205, "Bowl", "bowl|jade|jade", "as/mobile-large/193272.jpg", 1.35),
    SearchData(
        1587,
        39317,
        "Architectural Ensemble from a Jain Meeting Hall",
        "architectural ensemble|teak with traces of color|sculpture",
        "as/mobile-large/DT5057.jpg",
        1.25
    ),
    SearchData(
        1597,
        446563,
        "\"A Muslim Pilgrim Learns a Lesson in Piety from a Brahman\", Folio from a Khamsa (Quintet) of Amir Khusrau Dihlavi",
        "folio from an illustrated manuscript|image: ink, opaque watercolor, and gold on paper  margins: gold on dyed paper|codices",
        "is/mobile-large/DP159383.jpg",
        0.84
    ),
    SearchData(
        0,
        38364,
        "Two Lotuses, from the Bharhut Stupa",
        "architectural relief|red sandstone|sculpture",
        "as/mobile-large/DP-15581-042.jpg",
        1.45
    ),
    SearchData(
        0, 49910, "Plaque with the Goddess Durga Standing on a Lotus", "plaque|wood|sculpture",
        "as/mobile-large/2004_553_1.JPG", 0.32
    ),
    SearchData(
        1099,
        37531,
        "Stupa",
        "stupa|bronze|metalwork",
        "as/mobile-large/264772_3.jpg",
        0.59
    ),
    SearchData(
        699, 38413, "Head of a Bodhisattva", "head|stucco on a clay core|sculpture",
        "as/mobile-large/33_50_5_F_sf.jpg", 1.15
    ),
    SearchData(
        -249,
        38363,
        "Shard with Three Goddesses",
        "shard|terracotta|sculpture",
        "as/mobile-large/264805.jpg",
        0.89
    ),
    SearchData(
        1462,
        452780,
        "Fragment of a Cornice with a Frieze of Masks",
        "fragment of a cornice|sandstone|stone",
        "is/mobile-large/sf1975-197a.jpg",
        2.69
    ),
    SearchData(
        1800,
        24008,
        "Armor of Mail and Plate",
        "armor of mail and plate|steel, iron, copper alloy, textile|armor for man",
        "aa/mobile-large/DP151779.jpg",
        0.92
    ),
    SearchData(
        1800,
        31823,
        "Dagger (Pesh-kabz) with Sheath",
        "dagger (pesh-kabz) with sheath|steel, rock crystal, silver, enamel, velvet, wood|daggers",
        "aa/mobile-large/36.25.650ab_006june2014.jpg",
        0.56
    ),
    SearchData(
        -1250,
        50598,
        "Harpoon",
        "harpoon|copper|metalwork",
        "as/mobile-large/2001_433_61_O.JPG",
        0.46
    ),
    SearchData(
        1612,
        457019,
        "Engraved Bowl",
        "bowl|copper; cast, engraved, tinned, and inlaid with a black compound|metal",
        "is/mobile-large/DP246498.jpg",
        0.85
    ),
    SearchData(
        1649,
        446991,
        "Pen Box with Flowers, Birds and Animals",
        "pen box|ivory; carved, incised, and inlaid with black lacquer and gold|ivories and bone",
        "is/mobile-large/sf17-190-819a.jpg",
        4.05
    ),
    SearchData(
        1749,
        39450,
        "Guardian (Ainar)",
        "portable idol|brass|sculpture",
        "as/mobile-large/19_135_27.JPG",
        0.69
    ),
    SearchData(
        149,
        38740,
        "Head of Buddha",
        "head|stone|sculpture",
        "as/mobile-large/29_68_1.JPG",
        0.64
    ),
    SearchData(
        1949, 38543, "Standing Nagaraja (Study Collection)", "figure|stone|sculpture",
        "as/mobile-large/1991_453_1.JPG", 0.58
    ),
    SearchData(
        1750,
        31827,
        "Dagger with Sheath",
        "dagger with sheath|steel, gold, jade, beryl, ruby, emerald, topaz, silver, pearl, wood, velvet|daggers",
        "aa/mobile-large/36.25.654ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        -49, 38091, "Figures Riding an Elephant", "figure|terracotta|sculpture",
        "as/mobile-large/1987_142_378_F.jpg", 0.80
    ),
    SearchData(
        1750, 31824, "Dagger", "dagger|steel, nephrite, gold, ruby|daggers",
        "aa/mobile-large/36.25.651_001june2014.jpg", 0.56
    ),
    SearchData(
        1827,
        31466,
        "Dagger (Katar) with Sheath",
        "dagger (katar) with sheath|steel, gold, skin, silver|daggers",
        "aa/mobile-large/36.25.1070ab_002july2014.jpg",
        0.56
    ),
    SearchData(
        1675,
        30360,
        "Priming Flask",
        "priming flask|ivory, iron, copper alloy|firearms accessories-flasks & primers",
        "aa/mobile-large/36.25.2419_001AA2016.jpg",
        1.78
    ),
    SearchData(
        1249,
        38141,
        "Loving Couple (Mithuna)",
        "relief|ferruginous stone|sculpture",
        "as/mobile-large/DT241.jpg",
        0.80
    ),
    SearchData(
        1800,
        24319,
        "Saber",
        "saber|steel, jade (nephrite), gold|swords",
        "aa/mobile-large/DP163330.jpg",
        0.75
    ),
    SearchData(
        1725,
        31505,
        "Punch Dagger (Katar) with Sheath",
        "punch dagger (katar) with sheath|steel, iron, silver, gold, rubies|daggers",
        "aa/mobile-large/DP157417.jpg",
        1.72
    ),
    SearchData(
        450,
        38200,
        "Standing Balarama or Nagaraja (Serpent King)",
        "figure|red sandstone|sculpture",
        "as/mobile-large/1991_83_2_O.jpg",
        0.50
    ),
    SearchData(
        1799, 56224, "Sword handle", "sword handle|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/99832.jpg", 0.72
    ),
    SearchData(
        483,
        54489,
        "Mask of Vaikuntha Vishnu",
        "mask|bronze|sculpture",
        "as/mobile-large/DP141923.jpg",
        0.82
    ),
    SearchData(
        749,
        38253,
        "Gaja Lakshmi, Goddess of Fortune",
        "relief|stone|sculpture",
        "as/mobile-large/250880.jpg",
        0.80
    ),
    SearchData(
        1099,
        38131,
        "Carved Conch with Lakshmi-Narayana",
        "conch|shell with silver additions|shell",
        "as/mobile-large/DP-17092-001.jpg",
        0.75
    ),
    SearchData(
        912,
        39325,
        "Standing Parvati",
        "figure|copper alloy|metalwork",
        "as/mobile-large/DT239.jpg",
        0.75
    ),
    SearchData(
        -1250,
        50627,
        "Ax with Punch Marks",
        "ax|copper|metalwork",
        "as/mobile-large/2001_433_23.jpg",
        0.66
    ),
    SearchData(
        600, 38965, "Buddha Offering Protection", "figure|copper alloy|sculpture",
        "as/mobile-large/DP-15581-036.jpg", 0.68
    ),
    SearchData(
        1750, 24932, "Helmet", "helmet|steel, brass, gold, textile, metallic thread|helmets",
        "aa/mobile-large/1988.147_007mar2015.jpg", 0.67
    ),
    SearchData(
        1750,
        31837,
        "Dagger (Jambiya)",
        "dagger (jambiya)|steel, ivory (walrus), silver, ruby, rose quartz|daggers",
        "aa/mobile-large/LC-36_25_665-004.jpg",
        0.56
    ),
    SearchData(
        1620,
        444868,
        "Coin",
        "coin|silver|coins",
        "is/mobile-large/LC-99_35_7405.jpg",
        1.00
    ),
    SearchData(
        1600,
        454003,
        "Inlaid Box for the Portuguese Market",
        "box|wood (teak); veneered with ebony, inlaid ivory, and lac|wood",
        "is/mobile-large/DP217229.jpg",
        1.34
    ),
    SearchData(
        1816,
        24013,
        "Mail Shirt",
        "mail shirt|iron, copper alloys, leather|mail",
        "aa/mobile-large/DP147309.jpg",
        1.00
    ),
    SearchData(
        1799,
        56208,
        "Box with cover",
        "box|jade (nephrite)|jade",
        "as/mobile-large/02_18_760_O2.jpg",
        1.26
    ),
    SearchData(
        1637,
        451286,
        "\"Rosette Bearing the Names and Titles of Shah Jahan\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP240657.jpg",
        0.70
    ),
    SearchData(
        1617,
        444860,
        "Coin with Gemini Zodiac Sign",
        "coin|silver|coins",
        "is/mobile-large/DP221340.jpg",
        0.75
    ),
    SearchData(
        1800, 31846, "Dagger (Khanjar)", "dagger (khanjar)|steel, rock crystal, gold|daggers",
        "aa/mobile-large/36.25.676_001june2014.jpg", 0.56
    ),
    SearchData(
        999, 38152, "Chamunda, the Horrific Destroyer of Evil", "figure|sandstone|sculpture",
        "as/mobile-large/DT5234.jpg", 0.80
    ),
    SearchData(
        1699,
        457711,
        "Floral Canopy or Screen",
        "hanging|cotton, gold leaf; plain weave, painted|textiles",
        "is/mobile-large/DP330218.jpg",
        1.01
    ),
    SearchData(
        450,
        38394,
        "Male Figure",
        "figure|terracotta|sculpture",
        "as/mobile-large/1982_471_1.JPG",
        0.61
    ),
    SearchData(
        250, 38751, "Fragment of a Horse\"s Head", "statuette fragment|terracotta|sculpture",
        "as/mobile-large/33_50_15.JPG", 1.17
    ),
    SearchData(
        1099,
        705435,
        "Eight Great Events Stele",
        "stele|stone|sculpture",
        "as/mobile-large/DP-592-001.jpg",
        0.71
    ),
    SearchData(
        1618, 448257, "Inkpot of the Emperor Jahangir", "inkwell|nephrite, gold|stone",
        "is/mobile-large/DP216054.jpg", 0.89
    ),
    SearchData(
        949, 38930, "Shiva Seated with Uma (Umamaheshvara)", "statuette|bronze|sculpture",
        "as/mobile-large/1978_253_F_sf.jpg", 0.71
    ),
    SearchData(
        1683, 72598, "Upper Section of an Arch", "archway section|wood|woodwork",
        "as/mobile-large/2004_466_01_Strm1.jpg", 2.52
    ),
    SearchData(
        791,
        38133,
        "Enthroned Vishnu",
        "statue|granulite|sculpture",
        "as/mobile-large/DT5240.jpg",
        0.80
    ),
    SearchData(
        1800,
        31479,
        "Knife with Sheath",
        "knife with sheath|steel, jade, gold, ruby, gemstone, leather, silver|knives",
        "aa/mobile-large/36.25.1086ab_002july2014.jpg",
        0.56
    ),
    SearchData(
        1650,
        22100,
        "Priming Flask",
        "priming flask|ivory, wood, pigment, resin|firearms accessories-flasks & primers",
        "aa/mobile-large/DP158300.jpg",
        1.52
    ),
    SearchData(
        1885,
        500718,
        "Māhatī Vīṇa",
        "māhatī vīṇa|gourd, various materials|chordophone-lute-plucked-fretted",
        "mi/mobile-large/156798.jpg",
        1.95
    ),
    SearchData(
        149,
        38732,
        "Relief of a Mother Goddess(?)",
        "relief|terracotta|sculpture",
        "as/mobile-large/28_159_8.JPG",
        0.62
    ),
    SearchData(
        1712, 38048, "Shah Jahan Hunting Blackbuck with Trained Cheetahs",
        "|ink, gold, and opaque watercolor on paper|paintings", "as/mobile-large/DP156161.jpg", 1.51
    ),
    SearchData(
        550,
        38203,
        "Mother Goddess (Matrika)",
        "figure|gray schist|sculpture",
        "as/mobile-large/DT3648.jpg",
        0.58
    ),
    SearchData(
        1849, 56248, "Dagger", "dagger|nephrite, very dark green, almost black|jade",
        "as/mobile-large/02_18_787.JPG", 3.51
    ),
    SearchData(
        1750,
        454049,
        "Prince and Ladies in a Garden",
        "illustrated single work|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP246522.jpg",
        0.70
    ),
    SearchData(
        100, 38430, "Loving Couple (Mithuna)", "disk|double-molded terracotta|sculpture",
        "as/mobile-large/DT8565.jpg", 0.80
    ),
    SearchData(
        1149,
        38937,
        "Shadakshari Lokeshvara",
        "figure|bronze with silver and copper inlay|sculpture",
        "as/mobile-large/1982_457.jpg",
        0.62
    ),
    SearchData(
        966,
        75593,
        "Chakra-Purusha, the Personified Discus Weapon of Vishnu",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DP-20870-001.jpg",
        0.75
    ),
    SearchData(
        1687,
        453184,
        "Fragment of a Floorspread",
        "fragment|cotton; plain weave, mordant-painted and dyed, resist-dyed|textiles-rugs",
        "is/mobile-large/DP344703.jpg",
        2.02
    ),
    SearchData(
        849, 38384, "Four-Armed Durga Seated on Her Lion Vehicle", "stele|stone|sculpture",
        "as/mobile-large/1990_15.jpg", 0.71
    ),
    SearchData(
        1649,
        451313,
        "Portrait of Islam Khan Mashhadi",
        "illustrated single work|opaque watercolor and gold on paper|codices",
        "is/mobile-large/DT4816.jpg",
        0.66
    ),
    SearchData(1749, 447774, "Mirror", "mirror|jade|stone", "is/mobile-large/24.80.562.jpg", 0.61),
    SearchData(
        963,
        39326,
        "Standing Vishnu",
        "figure|copper alloy|metalwork",
        "as/mobile-large/DT329883.jpg",
        0.80
    ),
    SearchData(
        1574, 453343, "Pierced Window Screen", "screen|red sandstone; pierced, carved|stone",
        "is/mobile-large/sf1993-67-1a.jpg", 0.68
    ),
    SearchData(
        1799, 56227, "Bowl", "bowl|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP-14153-043.jpg", 1.33
    ),
    SearchData(
        999,
        39189,
        "Crowned Buddha",
        "shrine|bronze inlaid with silver, lapis lazuli, and rock crystal|sculpture",
        "as/mobile-large/16 NEW DP314094r4_61E.jpg",
        0.75
    ),
    SearchData(
        1790, 204015, "Four-light candelabrum", "candelabrum|ivory|natural substances-ivory",
        "es/mobile-large/DP-13853-069.jpg", 0.63
    ),
    SearchData(
        1800, 31686, "Dagger (Khanjar)", "dagger (khanjar)|steel, jade|daggers",
        "aa/mobile-large/36.25.706_001june2014.jpg", 0.56
    ),
    SearchData(
        -1000,
        50573,
        "Antennae Sword",
        "antennae sword|copper|metalwork",
        "as/mobile-large/2001_433_53_O.JPG",
        0.43
    ),
    SearchData(
        1650,
        32137,
        "Helmet",
        "helmet|steel, iron, copper alloy|helmets",
        "aa/mobile-large/DP151784.jpg",
        1.00
    ),
    SearchData(
        1750,
        22872,
        "Dagger with Sheath",
        "dagger with sheath|steel, nephrite, gold, emerald, ruby, diamond, sapphire, jade|daggers",
        "aa/mobile-large/DP158185.jpg",
        0.69
    ),
    SearchData(
        -50,
        39676,
        "One from a Pair of Ear Ornaments (Prakaravapra Kundala)",
        "earring|gold, sheet, wire and granulation|jewelry",
        "as/mobile-large/DP-14791-006.jpg",
        1.37
    ),
    SearchData(
        1099,
        39248,
        "Standing Surya",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DT4673.jpg",
        0.63
    ),
    SearchData(1618, 444859, "Coin", "coin|gold|coins", "is/mobile-large/DP25.jpg", 1.00),
    SearchData(
        1750,
        31442,
        "Knife (Kard) with Sheath",
        "knife (kard) with sheath|steel, nephrite, silver, gold, ruby, velvet, wood|daggers",
        "aa/mobile-large/36.25.1046ab_003july2014.jpg",
        0.56
    ),
    SearchData(
        -1000,
        50599,
        "Serrated Harpoon",
        "harpoon|copper|metalwork",
        "as/mobile-large/2001_433_69_O.JPG",
        0.42
    ),
    SearchData(
        1799,
        56236,
        "Bottle in the shape of a gourd",
        "bottle|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/02_18_779.JPG",
        0.58
    ),
    SearchData(
        1640,
        453188,
        "Dagger with Hilt of Leafy Plants",
        "dagger|hilt: nephrite  blade: watered steel|arms and armor",
        "is/mobile-large/DP158638.jpg",
        0.70
    ),
    SearchData(
        1772,
        456967,
        "A Gathering of Holy Men of Different Faiths",
        "illustrated single work|opaque watercolor and gold on paper|codices",
        "is/mobile-large/DP213133.jpg",
        0.76
    ),
    SearchData(
        1149,
        38137,
        "Shiva Emerging from the Linga (Lingodbhavamurti)",
        "carved pillar|gray stone|sculpture",
        "as/mobile-large/DP-16372-001.jpg",
        0.75
    ),
    SearchData(
        799,
        39344,
        "Linga with Face of Shiva (Ekamukhalinga)",
        "linga|brass with copper and silver inlay|sculpture",
        "as/mobile-large/DP-23782-001.jpg",
        0.75
    ),
    SearchData(
        1850, 31850, "Dagger (Khanjar)", "dagger (khanjar)|steel, jade, stone|daggers",
        "aa/mobile-large/36.25.680_001june2014.jpg", 0.56
    ),
    SearchData(
        272,
        38237,
        "Buddha",
        "torso|limestone|sculpture",
        "as/mobile-large/DP701399.jpg",
        0.72
    ),
    SearchData(
        1800, 31826, "Dagger (Khanjar)", "dagger (khanjar)|steel, jade, gold, silver|daggers",
        "aa/mobile-large/36.25.653_001june2014.jpg", 0.56
    ),
    SearchData(
        1625,
        444863,
        "Coin with Sign of Libra",
        "coin|gold|coins",
        "is/mobile-large/DP27.jpg",
        1.00
    ),
    SearchData(
        1625,
        457730,
        "Dagger with Zoomorphic Hilt",
        "dagger|hilt: copper; cast, chased, gilded, and inlaid with rubies.  blade: steel; forged|arms and armor",
        "is/mobile-large/DP253146.jpg",
        0.75
    ),
    SearchData(
        -1250,
        50592,
        "Anthropomorph",
        "anthropomorph|copper|metalwork",
        "as/mobile-large/2001_433_5.jpg",
        1.49
    ),
    SearchData(
        1597,
        822698,
        "Portrait of Kuchal Oghlan: Folio from Salim\"s Album",
        "album leaf, illustrated|opaque watercolor and gold on paper|codices",
        "is/mobile-large/TR.82.2019 3-28-19.jpg",
        0.65
    ),
    SearchData(
        1799,
        56219,
        "Mirror frame",
        "mirror frame|jade (nephrite)|jade",
        "as/mobile-large/ISL143.jpg",
        0.69
    ),
    SearchData(
        1800, 31685, "Dagger (Khanjar)", "dagger (khanjar)|steel, nephrite, gold, ruby|daggers",
        "aa/mobile-large/36.25.705_002june2014.jpg", 0.56
    ),
    SearchData(
        199,
        39124,
        "Seated Goddess",
        "figurine|bronze|sculpture",
        "as/mobile-large/1987_142_338_F.JPG",
        0.74
    ),
    SearchData(
        -1250, 50639, "Eccentric Anthropomorph", "anthropomorph|copper|metalwork",
        "as/mobile-large/2001_433_10_O.JPG", 0.93
    ),
    SearchData(
        -50,
        64486,
        "Yakshi Holding a Crowned Child with a Visiting Parrot",
        "plaque|terracotta|sculpture",
        "as/mobile-large/DP158763.jpg",
        0.75
    ),
    SearchData(
        1635, 453054, "Floral Tent Panel", "tent lining|silk, gold; cut velvet, painted|textiles",
        "is/mobile-large/DP210624.jpg", 2.05
    ),
    SearchData(
        1597,
        446560,
        "\"A King Offers to Make Amends to a Bereaved Mother\", Folio from a Khamsa (Quintet) of Amir Khusrau Dihlavi",
        "folio from an illustrated manuscript|main support: ink, opaque watercolor, gold on paper  margins: gold on dyed paper|codices",
        "is/mobile-large/DP120801.jpg",
        0.68
    ),
    SearchData(
        1650,
        453341,
        "Mango-Shaped Flask",
        "flask|rock crystal; set with gold, enamel, rubies, and emeralds|stone",
        "is/mobile-large/DP240307.jpg",
        0.75
    ),
    SearchData(
        1700,
        24029,
        "Helmet",
        "helmet|steel, iron, gold|helmets",
        "aa/mobile-large/DP152944.jpg",
        0.75
    ),
    SearchData(1617, 453435, "Coin", "coin|silver|coins", "is/mobile-large/99.35.6553.JPG", 1.07),
    SearchData(
        1112,
        38517,
        "Standing Vishnu as Keshava",
        "figure|stone|sculpture",
        "as/mobile-large/DT5252.jpg",
        0.54
    ),
    SearchData(
        1600, 453260, "Calligraphic Roundel, inscribed \"Ya \"Aziz\" (Oh Mighty)",
        "roundel|sandstone; carved, traces of pigment|stone", "is/mobile-large/DT8177.jpg", 0.80
    ),
    SearchData(
        1799, 56255, "Buckle", "buckle|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP108026.jpg", 1.25
    ),
    SearchData(
        1675,
        30363,
        "Priming Flask",
        "priming flask|ivory, iron, copper alloy|firearms accessories-flasks & primers",
        "aa/mobile-large/36.25.2423_004AA2016.jpg",
        1.78
    ),
    SearchData(
        666, 38559, "Vajrapani, the Thunderbolt-bearing Bodhisattva", "stele|stone|sculpture",
        "as/mobile-large/DP-15581-058.jpg", 0.74
    ),
    SearchData(
        1750,
        35949,
        "Cuirass (<i>Char-aina</i>) with Mail Shirt",
        "cuirass (<i>char-aina</i>) with mail shirt|steel, iron, gold, leather, textile|armor parts",
        "aa/mobile-large/DP147307.jpg",
        1.00
    ),
    SearchData(
        1780,
        457783,
        "Two Late Mughal Letters",
        "non-illustrated single work|ink and gold on paper|codices",
        "is/mobile-large/DP273298.jpg",
        0.59
    ),
    SearchData(
        150,
        38509,
        "Standing Indra",
        "standing indra|sandstone|sculpture",
        "as/mobile-large/DT5718.jpg",
        0.80
    ),
    SearchData(
        1612,
        453241,
        "Pierced Window Screen (Jali)",
        "screen|marble|stone",
        "is/mobile-large/DT7720.jpg",
        0.62
    ),
    SearchData(
        -50, 38734, "Bust of a Female Deity (Yakshi?)", "bust|gray clay|sculpture",
        "as/mobile-large/28_159_11.JPG", 0.80
    ),
    SearchData(
        599,
        38424,
        "Mirror Handle with a Woman Playing the Lute",
        "mirror handle|chlorite schist|sculpture",
        "as/mobile-large/DT8673.jpg",
        0.80
    ),
    SearchData(
        224, 38239, "Drum panel with Great Departure and Temptation of the Buddha scenes",
        "relief|limestone|sculpture", "as/mobile-large/DP-18911-001.jpg", 0.83
    ),
    SearchData(
        199,
        38733,
        "Head of a Female",
        "head|terracotta|sculpture",
        "as/mobile-large/28_159_10.JPG",
        0.80
    ),
    SearchData(
        1749,
        452777,
        "Bottle with Gilded Flowers",
        "bottle|glass, purple; mold blown, gilded|glass",
        "is/mobile-large/sf1975-194-2a.jpg",
        0.67
    ),
    SearchData(
        1597,
        446561,
        "\"Alexander is Lowered into the Sea\", Folio from a Khamsa (Quintet) of Amir Khusrau Dihlavi",
        "folio from an illustrated manuscript|main support: ink, watercolor, gold on paper  margins: gold on dyed paper|codices",
        "is/mobile-large/DP120802.jpg",
        0.67
    ),
    SearchData(
        1687,
        450750,
        "Sash (Patka)",
        "sash|cotton, silk; plain weave, embroidered|textiles-costumes",
        "is/mobile-large/DP272849.jpg",
        5.09
    ),
    SearchData(
        1749, 56218, "Dish in the shape of a chrysanthemum flower", "dish|jade (nephrite)|jade",
        "as/mobile-large/DP108023.jpg", 1.41
    ),
    SearchData(
        1099,
        38120,
        "Vishnu with His Consorts, Lakshmi and Sarasvati",
        "relief|black stone|sculpture",
        "as/mobile-large/57_51_7.jpg",
        0.83
    ),
    SearchData(
        1749, 77164, "Vessel in the form of a Mango", "vessel|silver and fabric|metalwork",
        "as/mobile-large/DP-23606-001.jpg", 1.33
    ),
    SearchData(
        -50,
        38487,
        "Disk Stone with a Four-Part Tracery Design of Palmettes",
        "disk stone|stone|sculpture",
        "as/mobile-large/DP-18252-016.jpg",
        1.33
    ),
    SearchData(
        550, 38492, "Lotus-Headed Fertility Goddess Lajja Gauri", "relief|sandstone|sculpture",
        "as/mobile-large/DP253528.jpg", 1.33
    ),
    SearchData(
        -1250,
        56621,
        "Harpoon",
        "harpoon|copper|metalwork",
        "as/mobile-large/2001_433_77_O.JPG",
        0.42
    ),
    SearchData(
        1649, 70582, "Dye-Patterned Silk", "lining|silk (clamp resist, dyed)|textiles-printed",
        "as/mobile-large/DP278411.jpg", 2.35
    ),
    SearchData(
        1783,
        65576,
        "Pichhwai for the Festival of Cows",
        "ceremonial cloth|painted and printed gold and silver leaf and opaque watercolor on indigo-dyed cotton|textiles-painted and printed",
        "as/mobile-large/DP156677.jpg",
        1.04
    ),
    SearchData(
        1749,
        444832,
        "Rock Crystal Box",
        "box|rock crystal; inlaid with gold, inset with rubies|stone",
        "is/mobile-large/LC-95_14_12.jpg",
        1.40
    ),
    SearchData(
        1675,
        24298,
        "Dagger with Sheath",
        "dagger with sheath|steel, nephrite, gold, rubies, emeralds, silver-gilt, leather|daggers",
        "aa/mobile-large/DP157696.jpg",
        0.73
    ),
    SearchData(
        549,
        38251,
        "Vishvarupa Vishnu",
        "sculpture|stone|sculpture",
        "as/mobile-large/DP-14892-001.jpg",
        1.33
    ),
    SearchData(
        949, 713008, "Miniature Brahmanical Shrine", "shrine|copper alloy|metalwork",
        "as/mobile-large/LC-2016_242_sr1-002.jpg", 0.65
    ),
    SearchData(
        816, 39194, "Vishnu Flanked by His Personified Attributes", "group|bronze|sculpture",
        "as/mobile-large/DP702345.jpg", 0.63
    ),
    SearchData(
        1617,
        444857,
        "Coin",
        "coin|silver|coins",
        "is/mobile-large/LC-99.35.2385.jpg",
        1.50
    ),
    SearchData(
        1649,
        56228,
        "Jewelled Dagger Handle",
        "dagger-handle|nephrite, white with faint bluish tint|jade",
        "as/mobile-large/99834.jpg",
        0.74
    ),
    SearchData(
        633, 78430, "Mask of Bhairava", "mask|copper alloy, possibly brass|sculpture",
        "as/mobile-large/DP702309.jpg", 0.70
    ),
    SearchData(
        1010, 768115, "Shiva as Vanquisher of the Three Cities (Shiva Tripuravijaya)",
        "figure|copper alloy|sculpture", "as/mobile-large/DP-16371-002.jpg", 0.75
    ),
    SearchData(
        1580,
        451262,
        "\"Great Hornbill\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP246533.jpg",
        1.46
    ),
    SearchData(
        850, 39340, "Crowned and Jeweled Buddha", "sculpture|copper with silver inlay|metalwork",
        "as/mobile-large/1983_555_4_O.jpg", 0.58
    ),
    SearchData(
        -200, 38431, "Standing Female Deity", "figure|terracotta, black oxidation patina|sculpture",
        "as/mobile-large/DP251647.jpg", 0.75
    ),
    SearchData(
        949, 38615, "Stele with Eight Great Events from the Life of the Buddha",
        "stele|black schist with traces of gilding|sculpture", "as/mobile-large/11r1_61B.jpg", 0.75
    ),
    SearchData(
        1612,
        452680,
        "Reception of a Persian Ambassador by a Mughal Prince",
        "illustrated  album leaf|opaque watercolor and gold on paper|codices",
        "is/mobile-large/DP291186.jpg",
        1.01
    ),
    SearchData(
        -50,
        64487,
        "Pot",
        "pot|ceramic|ceramics",
        "as/mobile-large/2001_588_Strm1.JPG",
        1.51
    ),
    SearchData(
        1749,
        447773,
        "Bowl with Acanthus Leaf Handles",
        "bowl|nephrite|stone",
        "is/mobile-large/sf24-80-141b.jpg",
        1.20
    ),
    SearchData(
        799,
        38154,
        "Torso of a Hindu Deity",
        "figure|stone|sculpture",
        "as/mobile-large/33_65_1_F.JPG",
        0.59
    ),
    SearchData(
        -1250,
        50626,
        "Ax with Punch Marks",
        "ax|copper|metalwork",
        "as/mobile-large/2001_433_22.jpg",
        0.67
    ),
    SearchData(
        -1000,
        39432,
        "Anthropomorph",
        "anthropomorph|copper|metalwork",
        "as/mobile-large/2000_284_37.jpg",
        0.81
    ),
    SearchData(
        -99,
        38079,
        "Ring Stone",
        "ringstone fragment|stone|sculpture",
        "as/mobile-large/1987_142_374_O.jpg",
        1.84
    ),
    SearchData(
        150, 38264, "Head of a Demonic Male Deity", "head|mottled red sandstone|sculpture",
        "as/mobile-large/DT8557.jpg", 0.80
    ),
    SearchData(
        1775,
        22938,
        "Smallsword with Scabbard",
        "smallsword with scabbard|steel, gold, wood, leather, textile|swords",
        "aa/mobile-large/LC-26_145_338a_b-002.jpg",
        0.71
    ),
    SearchData(
        1605,
        37936,
        "Six Gopis Seated Beneath Trees:  Page from a Dispersed Bhagavata Purana (Ancient Stories of Lord Vishnu)",
        "folio|ink and opaque watercolor on paper|paintings",
        "as/mobile-large/DP152322.jpg",
        2.79
    ),
    SearchData(
        1149, 39193, "Jain Digambara Tirthanhara Standing in Kayotsarga Meditation Posture",
        "figure|copper alloy|sculpture", "as/mobile-large/DP-593-001.jpg", 0.61
    ),
    SearchData(
        250, 38755, "Relief of a Female Deity", "relief fragment|terracotta|sculpture",
        "as/mobile-large/33_50_19.JPG", 0.73
    ),
    SearchData(
        -1250,
        50619,
        "Ax Blade (Celt)",
        "ax blade|copper|metalwork",
        "as/mobile-large/2001_433_19_O.JPG",
        0.87
    ),
    SearchData(
        600,
        39128,
        "Tara",
        "figure|copper alloy|sculpture",
        "as/mobile-large/DP253393.jpg",
        0.75
    ),
    SearchData(
        1800,
        31825,
        "Dagger (Khanjar) with Sheath",
        "dagger (khanjar) with sheath|steel, jade, gold, ruby, emerald, diamond, silver, pearl, wood, velvet|daggers",
        "aa/mobile-large/36.25.652ab_003june2014.jpg",
        0.56
    ),
    SearchData(
        -100, 38087, "Plaque with Goddess and Attendant", "plaque|terracotta|sculpture",
        "as/mobile-large/1987_417_3.jpg", 0.65
    ),
    SearchData(
        1800,
        31862,
        "Dagger (Katar) with Sheath",
        "dagger (katar) with sheath|steel, gold, ruby, emerald, diamond, wood, velvet|daggers",
        "aa/mobile-large/36.25.692ab_010june2014.jpg",
        0.56
    ),
    SearchData(
        1710,
        454619,
        "The Emperor Aurangzeb Carried on a Palanquin",
        "illustrated single work|opaque watercolor and gold on paper|codices",
        "is/mobile-large/DP116022.jpg",
        0.68
    ),
    SearchData(
        1700, 32259, "Dagger", "dagger|steel, jade, ruby, gold|daggers",
        "aa/mobile-large/32.75.264_001june2014.jpg", 0.56
    ),
    SearchData(
        1850, 21922, "Shield (Dhál)", "shield (dhàl)|steel, gold, silk-velvet|shields",
        "aa/mobile-large/sfma02.5.4_165461.jpg", 0.96
    ),
    SearchData(
        1649,
        452813,
        "Flower-Style Box with Drawers",
        "box|wood (poplar); overlaid with ebony inlaid with wood and incised, stained ivory|wood",
        "is/mobile-large/wb-1976.176.1b.JPG",
        1.50
    ),
    SearchData(
        -149, 38924, "Goddess with Weapons in Her Hair", "figure|copper alloy|sculpture",
        "as/mobile-large/DP252968.jpg", 0.69
    ),
    SearchData(
        1700,
        33536,
        "Hilt of a Dagger",
        "hilt of a dagger|nephrite|daggers",
        "aa/mobile-large/DP158302.jpg",
        0.84
    ),
    SearchData(
        1875,
        500764,
        "Turhā or Karnā",
        "turhā or karnā|brass|aerophone-lip vibrated-trumpet / trombone",
        "mi/mobile-large/DP-12679-003.jpg",
        1.97
    ),
    SearchData(
        1850, 31689, "Dagger (Khanjar)", "dagger (khanjar)|steel, horn, ruby|daggers",
        "aa/mobile-large/36.25.709_002june2014.jpg", 0.56
    ),
    SearchData(
        983,
        39608,
        "Celestial Attendant",
        "figure|bronze|sculpture",
        "as/mobile-large/1996_475_O1.jpg",
        1.33
    ),
    SearchData(
        -283,
        38084,
        "Ring stone with goddesses and aquatic plants",
        "ring stone|steatite (?)|sculpture",
        "as/mobile-large/DP-18252-025.jpg",
        1.33
    ),
    SearchData(
        424, 38242, "Linga with Face of Shiva (Ekamukhalinga)", "linga|sandstone|sculpture",
        "as/mobile-large/DP297454.jpg", 0.75
    ),
    SearchData(
        1700,
        457771,
        "A Bejewelled Maiden with a Parakeet",
        "illustrated single work|opaque watercolor and gold on paper|codices",
        "is/mobile-large/DP269558.jpg",
        0.70
    ),
    SearchData(
        1600,
        456312,
        "Spittoon or Incense Burner",
        "spittoon|brass; cast in sections, joined, engraved|metal",
        "is/mobile-large/DP231251.jpg",
        0.75
    ),
    SearchData(
        499, 40076, "Tile with Impressed Figure of Emaciated Ascetics and Couples Behind Balconies",
        "tile|terracotta|ceramics", "as/mobile-large/1998_122.jpg", 0.76
    ),
    SearchData(
        1799, 56230, "Jewelled plate", "plate|jade (nephrite) with gold and stone inlays|jade",
        "as/mobile-large/DP-14153-029.jpg", 1.14
    ),
    SearchData(1649, 56204, "Bowl", "bowl|nephrite|jade", "as/mobile-large/32883.jpg", 1.41),
    SearchData(
        1750,
        24425,
        "Lance",
        "lance|steel, gold,  silver|shafted weapons",
        "aa/mobile-large/DP210386.jpg",
        0.42
    ),
    SearchData(
        -1,
        38367,
        "Toy",
        "toy|terracotta|sculpture",
        "as/mobile-large/1984_491_16.jpg",
        1.00
    ),
    SearchData(850, 37400, "Stupa", "stupa|bronze|sculpture", "as/mobile-large/264819.jpg", 0.75),
    SearchData(
        50,
        38746,
        "Figure of a Ram",
        "statuette|terracotta|sculpture",
        "as/mobile-large/33_50_8.JPG",
        1.45
    ),
    SearchData(
        885, 38252, "Four-Armed Goddess, possibly Sarada", "figure|chlorite schist|sculpture",
        "as/mobile-large/DT5248.jpg", 0.80
    ),
    SearchData(
        1949,
        72384,
        "Standing Buddha",
        "figure|bronze|sculpture",
        "as/mobile-large/271785.jpg",
        0.61
    ),
    SearchData(
        1700,
        454738,
        "Goa Stone and Gold Case",
        "goa stone and container|container: gold; pierced, repoussé, with cast legs and finials  goa stone: compound of organic and inorganic materials|metal",
        "is/mobile-large/DP116018.jpg",
        1.00
    ),
    SearchData(
        450,
        38219,
        "Ear Plug with Kinnari (Half-Bird, Half-Female Creature)",
        "ear plug|terracotta|sculpture",
        "as/mobile-large/1987_142_390.jpg",
        1.15
    ),
    SearchData(
        1150,
        73214,
        "Model of the Mahabodhi Temple",
        "temple model|quartz-muscovite-chlorite-talc phyllite|sculpture",
        "as/mobile-large/8 NEW DP257785r1_61E.jpg",
        0.75
    ),
    SearchData(
        1627,
        451270,
        "\"Shah Jahan on a Terrace, Holding a Pendant Set With His Portrait\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP246547.jpg",
        0.67
    ),
    SearchData(
        1585,
        451265,
        "\"Portrait of Maharaja Bhim Kanwar\", Folio from the Shah Jahan Album",
        "album leaf|ink, opaque watercolor, and gold on paper|codices",
        "is/mobile-large/DP246545.jpg",
        0.67
    ),
    SearchData(
        449, 38731, "Head of a Buddha", "head|mottled red and white sandstone|sculpture",
        "as/mobile-large/28_159_5.JPG", 0.64
    ),
    SearchData(
        1850, 31443, "Dagger (Khanjar)", "dagger (khanjar)|steel, rock crystal|daggers",
        "aa/mobile-large/36.25.1047_001july2014.jpg", 0.56
    ),
    SearchData(
        449,
        38205,
        "Standing Four-Armed Vishnu",
        "figure|terracotta|sculpture",
        "as/mobile-large/DP323567.jpg",
        0.75
    ),
    SearchData(
        50,
        38728,
        "Head of Buddha",
        "head|red sandstone|sculpture",
        "as/mobile-large/28_97_2.JPG",
        0.74
    ),
    SearchData(
        453, 38199, "Standing Nagaraja (Serpent King)", "figure|red sandstone|sculpture",
        "as/mobile-large/1991_83_1_O.jpg", 0.55
    ),
    SearchData(
        949,
        74100,
        "Dancing Ganesha",
        "figure|mottled red sandstone|sculpture",
        "as/mobile-large/DP158921.jpg",
        0.75
    ),
    SearchData(
        1149,
        74502,
        "The Goddess Durga Slaying the Demon Buffalo Mahisha",
        "figure|brass|sculpture",
        "as/mobile-large/DP231297.jpg",
        0.75
    ),
    SearchData(
        1949,
        44669,
        "Standing Nagini (Study Collection)",
        "figure||sculpture",
        "as/mobile-large/1991_453_2.JPG",
        0.48
    ),
    SearchData(
        9,
        39345,
        "Crowned  Buddha",
        "figure|brass|sculpture",
        "as/mobile-large/DT229537.jpg",
        0.80
    ),
    SearchData(
        1749,
        452734,
        "Gilded Green Bottle",
        "bottle|glass, green; mold blown, gilded, and silvered|glass",
        "is/mobile-large/sf1975-64a.jpg",
        0.57
    ),
    SearchData(
        1793,
        24490,
        "Flintlock Blunderbuss",
        "flintlock blunderbuss|steel, wood, gold, silver|firearms",
        "aa/mobile-large/DP165542.jpg",
        2.07
    ),
    SearchData(
        749, 37412, "Panel of a Portable Buddhist Shrine with Dancer and Musician Celebrants",
        "panel|ivory with traces of color|ivories", "as/mobile-large/1988_148_1.jpg", 1.34
    ),
    SearchData(
        -249, 38086, "Sphere with Scenes of Rites at the Shrine of a Yaksha (Male Nature Spirit)",
        "sphere|stone|sculpture", "as/mobile-large/DP-18252-030.jpg", 1.33
    ),
    SearchData(
        1674, 452815, "Shield with Hunting and Landscape Vignettes",
        "shield|steel; with gold overlay|arms and armor", "is/mobile-large/DP153429.jpg", 1.25
    ),
    SearchData(
        1786,
        24328,
        "Saber (Talwar) with Scabbard",
        "saber (talwar) with scabbard|steel, silver, diamonds enamel, leather|swords",
        "aa/mobile-large/DP163746.jpg",
        0.77
    ),
    SearchData(
        1850, 31844, "Dagger (Khanjar)", "dagger (khanjar)|steel, nephrite, ruby, gold|daggers",
        "aa/mobile-large/36.25.674_002june2014.jpg", 0.56
    ),
    SearchData(
        1800,
        31681,
        "Dagger (Pesh-kabz) with Sheath",
        "dagger (pesh-kabz) with sheath|jade, steel, silver, wood, velvet, ruby, gold|daggers",
        "aa/mobile-large/36.25.700ab_002june2014.jpg",
        0.56
    ),
    SearchData(
        116,
        38381,
        "Princely Couple",
        "relief|terracotta|sculpture",
        "as/mobile-large/31_82_6.JPG",
        0.70
    ),
    SearchData(
        1792, 203778, "Chandelier", "chandelier|ivory|natural substances-ivory",
        "es/mobile-large/DP-13853-084.jpg", 1.00
    ),
    SearchData(
        1000, 39489, "Meditating Buddha with Alms Bowl Enthroned in a Foliated Niche",
        "architectural element|stone|sculpture", "as/mobile-large/DP158746.jpg", 1.33
    ),
)